import { createFileRoute } from "@tanstack/react-router";
import { marketingHead } from "../marketing-content/head";

import { MarketingPage } from "../components/marketing/MarketingPage";
import { MarketingLayout } from "../components/marketing/MarketingLayout";

function Homepage() {
  return (
    <MarketingLayout>
      <MarketingPage />
    </MarketingLayout>
  );
}

export const Route = createFileRoute("/homepage")({
  head: () => marketingHead("/homepage"),
  component: Homepage,
});
